import React from "react";
import { FileSpreadsheet, FileDown, Printer } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { useReportBranch } from "@/contexts/ReportBranchContext";
import { exportVisibleReport } from "@/lib/reportExport";
import { resolveReportLetterhead } from "@/lib/reportPrintShell";

export default function ReportExportButtons({
  disabled,
  title,
  filename,
  period,
  onPrint,
  printTestId,
}) {
  const { user } = useAuth();
  const { branchId, allBranches } = useReportBranch();

  const runExport = async (format) => {
    try {
      const company = await resolveReportLetterhead({ branchId, allBranches });
      exportVisibleReport({ format, title, filename, period, company, user });
      toast.success(format === "excel" ? "Excel downloaded" : "PDF downloaded");
    } catch (err) {
      toast.error(err?.message || `${format === "excel" ? "Excel" : "PDF"} export failed`);
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-2">
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="h-9 text-emerald-700 border-emerald-200 hover:bg-emerald-50 hover:text-emerald-800"
        data-testid="report-export-excel"
        disabled={disabled}
        onClick={() => runExport("excel")}
      >
        <FileSpreadsheet size={14} className="mr-1.5" />
        Excel
      </Button>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="h-9 text-rose-700 border-rose-200 hover:bg-rose-50 hover:text-rose-800"
        data-testid="report-export-pdf"
        disabled={disabled}
        onClick={() => runExport("pdf")}
      >
        <FileDown size={14} className="mr-1.5" />
        PDF
      </Button>
      {onPrint && (
        <Button
          type="button"
          variant="outline"
          size="sm"
          className="h-9"
          data-testid={printTestId}
          disabled={disabled}
          onClick={onPrint}
        >
          <Printer size={14} className="mr-1.5" /> Print
        </Button>
      )}
    </div>
  );
}
